import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/auth/updatePassword';

import { setPassword } from './utils';

export default function* listenSetPassword() {
  yield takeEvery(actionTypes.setPassword.toString(), setPassword);
}
